// extracted by mini-css-extract-plugin
export default {"page":"styles_page__myD6k","documentWrapper":"styles_documentWrapper__Hy51g"};